import Select from "~/common/components/ui/select/Select";
import {
  ZOOM_SESSION_HEADER_TYPE_OPTIONS,
  ZOOM_SESSION_TYPE_OPTIONS,
} from "~/providers/constants/zoomSessionType";
import { ZoomSessionType } from "~/providers/utils/types/zoomMeetingTypes";

interface SessionTypeSelectProps {
  value: ZoomSessionType | null | undefined;
  onChange: (sessionType: ZoomSessionType | null) => void;
  isDisabled?: boolean;
  variant?: "table" | "default";
}

export const SessionTypeSelect = ({
  value,
  onChange,
  isDisabled = false,
  variant = "default",
}: SessionTypeSelectProps) => {
  const handleSelectClick = (event?: React.MouseEvent) => {
    event?.stopPropagation();
  };

  const handleChange = (selectedValue: string | number) => {
    onChange(selectedValue ? (String(selectedValue) as ZoomSessionType) : null);
  };

  if (variant === "table") {
    return (
      <Select
        options={ZOOM_SESSION_TYPE_OPTIONS}
        id="session_type"
        value={value ?? ""}
        isDisabled={isDisabled}
        buttonClassName="border-none bg-transparent px-0 py-0 h-full font-normal text-gray-70"
        containerClassName="min-w-28 font-normal"
        optionsAnchor="bottom start"
        onChange={handleChange}
        onClick={handleSelectClick}
        optionsOnClick={handleSelectClick}
      />
    );
  }

  return (
    <Select
      options={ZOOM_SESSION_HEADER_TYPE_OPTIONS}
      id="session_type"
      value={value ?? ""}
      isDisabled={isDisabled}
      containerClassName="h-full w-48 z-30"
      buttonClassName="h-full"
      onChange={handleChange}
    />
  );
};
